import classNames from "classnames";
import Link from '@/components/AppLink';
import { useMemo } from "react";
import {
  formatFormApplicationTimestamp,
  getFormApplicationTypeMeta,
} from "@/app/inbox/forms/_constants/formsApplications.const";
import { Button } from "@/components";
import { useOverviewUnreadFormsQuery } from "../../_hooks/useOverviewUnreadFormsQuery";
import { OverviewSection } from "../overview-section";
import panelStates from "../overview-panel-states/OverviewPanelStates.module.scss";
import styles from "./OverviewRecentFormsSection.module.scss";

export const OverviewRecentFormsSection = () => {
  const { data, isLoading, isError, refetch } = useOverviewUnreadFormsQuery();

  const items = useMemo(() => {
    const raw = data?.items ?? [];
    return raw
      .filter((a) => !a.read)
      .sort((a, b) => b.createdAt - a.createdAt)
      .slice(0, 4);
  }, [data?.items]);

  return (
    <OverviewSection
      title="Latest unread forms"
      href="/inbox/forms"
    >
      {isLoading ? (
        <div className={panelStates["state"]}>
          <div className={panelStates["spinner"]} />
          <span>Loading forms…</span>
        </div>
      ) : null}

      {isError && !isLoading ? (
        <div className={panelStates["state"]}>
          <span>Couldn&apos;t load forms.</span>
          <Button size="small" variant="secondary" onClick={() => refetch()}>
            Retry
          </Button>
        </div>
      ) : null}

      {!isLoading && !isError && items.length === 0 ? (
        <div className={panelStates["state"]}>No unread form submissions.</div>
      ) : null}

      {!isLoading && !isError && items.length > 0 ? (
        <div className={styles["list"]}>
          {items.map((application) => {
            const typeMeta = getFormApplicationTypeMeta(application.type);
            return (
              <Link
                key={application.id}
                href="/inbox/forms"
                className={styles["row"]}
              >
                <div className={styles["row__main"]}>
                  <div className={styles["row__name"]}>{application.fullName}</div>
                  <div className={styles["row__preview"]}>{application.content}</div>
                </div>
                <div className={styles["row__aside"]}>
                  <span
                    className={classNames(
                      styles["badge"],
                      styles[`badge--${typeMeta.variant}`]
                    )}
                  >
                    {typeMeta.label}
                  </span>
                  <time className={styles["time"]}>
                    {formatFormApplicationTimestamp(application.createdAt)}
                  </time>
                </div>
              </Link>
            );
          })}
        </div>
      ) : null}
    </OverviewSection>
  );
};
